(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        (function () {
            const _ = require('lodash');
            const facebookAdObjectTypes = require('../../../public/enums/facebookAdObjectTypes.js');

            definition(module.exports, facebookAdObjectTypes, _);
        })();
    } else {
        (function () {
            RivalIQ.apps.AdsInsights.module('utils');

            const facebookAdObjectTypes = RivalIQ.enums.facebookAdObjectTypes;

            definition(RivalIQ.apps.AdsInsights.utils, facebookAdObjectTypes, window._);

        })();
    }

    function definition(utils, facebookAdObjectTypes, _) {

        const adObjectLevels = [
            facebookAdObjectTypes.ACCOUNT,
            facebookAdObjectTypes.CAMPAIGN,
            facebookAdObjectTypes.ADSET,
            facebookAdObjectTypes.AD
        ];

        utils.childExploreLevel = function (currentLevel) {
            switch (currentLevel) {
                case facebookAdObjectTypes.ACCOUNT:
                    return facebookAdObjectTypes.CAMPAIGN;
                case facebookAdObjectTypes.CAMPAIGN:
                    return facebookAdObjectTypes.ADSET;
                case facebookAdObjectTypes.ADSET:
                    return facebookAdObjectTypes.AD;
                default:
                    break;
            }
        };

        utils.adObjectAppPath = function (adAccountId, adObjectId, adObjectType) {
            const exploreLevel = utils.childExploreLevel(adObjectType);

            // 'ads/facebook(/:adAccountId)(/:adObjectId)(/:exploreLevel)'
            let url = `/ads/facebook/${adAccountId}/${adObjectId}`;
            if (exploreLevel) {
                url += (`/${exploreLevel}`);
            }

            return url;
        };

        utils.constructParentAdObject = function (adObject) {
            if (adObject.adObjectType === facebookAdObjectTypes.ACCOUNT) {
                return adObject;
            }

            const parentBreadcrumbLevels = _.takeWhile(adObjectLevels, function (level) {
                return level !== adObject.adObjectType;
            });

            const parent = {
                adAccountId: adObject.adAccountId
            };
            parent.adObjectType = _.last(parentBreadcrumbLevels);
            parent.id = adObject[`${parent.adObjectType}_id`];

            return _.reduce(parentBreadcrumbLevels, function (memo, adObjectType) {
                memo[`${adObjectType}_id`] = adObject[`${adObjectType}_id`];
                memo[`${adObjectType}_name`] = adObject[`${adObjectType}_name`];
                return memo;
            }, parent);
        };

        utils.getBreadCrumbsForAdObject = function (adAccountId, adObjectId, adObject) {

            return _.reduce(adObjectLevels, function (memo, adObjectType) {
                const adObjectId = adObject[`${adObjectType}_id`];

                if (adObjectId) {
                    const breadcrumbName = (adObjectId === adObject.adAccountId ? 'Entire Account' : adObject[`${adObjectType}_name`]);
                    const adObjectName = adObject[`${adObjectType}_name`];

                    memo.push({
                        breadcrumbName: breadcrumbName,
                        adObjectName: adObjectName,
                        href: utils.adObjectAppPath(adAccountId, adObjectId, adObjectType)
                    });
                }

                return memo;
            }, []);

        };

        // if linkToOwnLevel is truthy, the link generated will be to the view of this ad object amongst its
        // peers in ads manager; otherwise, the link will be to the children of adObject.
        utils.constructNativeLink = function (adObject, linkToOwnLevel) {

            const isAccountId = adObject.account_id.startsWith('act_');

            // strip off the leading 'act_'; this is one place that facebook doesn't like the prefix.
            const accountId = (isAccountId ? adObject.account_id.substring(4) : adObject.account_id);
            let selectedIdsParam;

            switch (adObject.adObjectType) {
                case facebookAdObjectTypes.CAMPAIGN:
                    selectedIdsParam = `&selected_campaign_ids=${adObject.id}`;
                    break;
                case facebookAdObjectTypes.ADSET:
                    selectedIdsParam = `&selected_ad_set_ids=${adObject.id}`;
                    break;
                case facebookAdObjectTypes.AD:
                    selectedIdsParam = `&selected_ad_ids=${adObject.id}`;
                    break;

                default:
                    selectedIdsParam = '';
            }

            let exploreLevel = utils.childExploreLevel(adObject.adObjectType);
            if (linkToOwnLevel || !exploreLevel) {
                exploreLevel = adObject.adObjectType;
            }

            return [
                'https://business.facebook.com/ads/manager/account/',
                `${exploreLevel}s`,
                `?act=${accountId}`,
                selectedIdsParam
            ].join('');
        };

    }

})();
